export function getSessionHeaders({ visitorId, sessionId }) {
  return {
    'x-visitor-id': visitorId,
    'x-session-id': sessionId,
  };
}
